// Typed static client for the /escript/* endpoints (SD-2337 / PR 3a).
// All-static, returns typed data (never a raw AxiosResponse), rethrows errors.
// Follows the PositiveIdService precedent.

import axios from 'axios'
import { EscriptResponse } from '@/models/Escript'

export class EscriptService {
    /** Get the full escript response by escript id. */
    static async getById(escriptId: number): Promise<EscriptResponse> {
        const response = await axios.get<EscriptResponse>(`/escript/${escriptId}`)
        return response.data
    }

    /**
     * Get the escript for a prescription. Cancellable via an AbortSignal — this is
     * the CancelToken → AbortController port. In axios 1.x an aborted request
     * rejects with a CanceledError that axios.isCancel() still recognizes, so the
     * call site's existing isCancel handling keeps working.
     */
    static async getForRx(rxId: string, signal?: AbortSignal): Promise<EscriptResponse> {
        const response = await axios.get<EscriptResponse>(`/escript/prescription/${rxId}`, { signal })
        return response.data
    }

    /** Trigger an escript redraw. */
    static async redraw(escriptId: number): Promise<void> {
        await axios.get(`Escript/Redraw/${escriptId}`)
    }
}

export default EscriptService
